// eslint-disable-next-line wandb/no-deprecated-imports
import styled from 'styled-components';

export const AgentHeader = styled.div`
  display: flex;
  align-items: flex-start;
  padding-bottom: 8px;
`;
AgentHeader.displayName = 'S.AgentHeader';

export const AgentNamePanel = styled.div`
  flex: 1 1 auto;
  display: flex;
  align-items: center;
`;
AgentNamePanel.displayName = 'S.AgentName';

export const AgentName = styled.span`
  font-size: 24px;
  font-weight: 600;
  line-height: 32px;
  margin-right: 8px;
`;
AgentName.displayName = 'AgentName';
